import { render } from "./add-edit-linked-practice-modal.html?vue&type=template&id=7973a0f9&scoped=true&ts=true&external"
import script from "./add-edit-linked-practice-modal.ts?vue&type=script&lang=ts&external"
export * from "./add-edit-linked-practice-modal.ts?vue&type=script&lang=ts&external"

import "./add-edit-linked-practice-modal.scss?vue&type=style&index=0&id=7973a0f9&scoped=true&lang=sccs&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7973a0f9"]])

export default __exports__